module.exports = __webpack_public_path__ + "img/1.7.Chla.ca40d3eb.png";